import axios from 'axios';
import {useCallback, useState} from 'react';
import {apiSupportStorage} from '~/modules/firebase';

export const useJsonDataFromStorage = <TData = any>({
  storageFilePath,
}: {
  storageFilePath: string;
}) => {
  const [isFetching, setFetching] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState<TData | null>(null);

  const fetchFileData = useCallback(() => {
    if (storageFilePath) {
      setFetching(true);
      const gsReference = apiSupportStorage.refFromURL(storageFilePath);
      gsReference.getDownloadURL().then(url => {
        axios(url, {responseType: 'blob'})
          .then(response => {
            const reader = new FileReader();
            reader.readAsText(response.data);
            reader.onload = e => {
              setData(JSON.parse(e.target?.result as string) as TData);
            };
          })
          .catch(error => {
            setError(error);
          })
          .finally(() => {
            setFetching(false);
          });
      });
    }
  }, [storageFilePath]);

  return {
    isFetching,
    error,
    data,
    fetchFileData,
  };
};
